module.exports = __webpack_public_path__ + "static/media/wide.c49bd40e.jpg";